import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { applicationTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { TerminalSolutionCreateDto } from "types/api";

type UseAddTerminalSolutionByApplicationMutationProps = {
	applicationId: string | undefined;
	onSuccess?: Function;
	onError?: Function;
};

const useAddTerminalSolutionByApplicationMutation = ({
	applicationId,
	onSuccess,
	onError,
}: UseAddTerminalSolutionByApplicationMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		(data: TerminalSolutionCreateDto) => {
			return applicationTerminalService.addTerminalSolution({
				application_id: applicationId,
				...data,
			});
		},
		{
			onSuccess(result) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Terminal has been created successfully",
					}),
				);
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useAddTerminalSolutionByApplicationMutation;
